import StudentAnswersView from "@features/tools/view/interactive-materials-view/single-interactive-material-view/student-answers";

const StudentAnswersPage = () => {
  return <StudentAnswersView />;
};

export default StudentAnswersPage;
